import useApiPrivateClient from "../../hooks/useApiPrivateClient";

export enum UploadMediaType {
  POI_AUDIO = 'poi-audio',
  AMBIENT = 'ambient',
  IMAGE = 'image',
}

export interface InitiateUploadRequest {
  mediaType: UploadMediaType;
  filename: string;
  languageCode?: string;
  contentType: string;
}

export interface InitiateUploadResponse {
  uploadSessionId: string;
  uploadUrl: string;
  objectKey: string;
  expiresAt: string;
}

export interface CompleteUploadRequest {
  uploadSessionId: string;
  etag?: string;
  bytes?: number;
}

export interface CommitUploadRequest {
  uploadSessionId: string;
  mediaType: UploadMediaType;
  filename: string;
  languageCode?: string;
}

export const useUploadService = () => {
  const apiPrivateClient = useApiPrivateClient();
  const uploadBasePath = "/edits/routes";

  const initiateUpload = (
    routeId: string,
    request: InitiateUploadRequest
  ) => {
    return apiPrivateClient.post<InitiateUploadResponse>(
      `${uploadBasePath}/${routeId}/uploads/initiate`,
      request
    );
  };

  const completeUpload = (
    routeId: string,
    request: CompleteUploadRequest
  ) => {
    return apiPrivateClient.post(
      `${uploadBasePath}/${routeId}/uploads/complete`,
      request
    );
  };

  const commitUpload = (
    routeId: string,
    request: CommitUploadRequest
  ) => {
    return apiPrivateClient.post(
      `${uploadBasePath}/${routeId}/uploads/commit`,
      request
    );
  };

  const abortUpload = (
    routeId: string,
    uploadSessionId: string
  ) => {
    return apiPrivateClient.delete(
      `${uploadBasePath}/${routeId}/uploads/${uploadSessionId}`
    );
  };

  return {
    initiateUpload,
    completeUpload,
    commitUpload,
    abortUpload,
  };
};

export default useUploadService;
